// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetFlatTourBookingScheduleRequest,
  TGetFlatTourBookingScheduleModel,
  IMappers,
  TGetFlatTourBookingScheduleResponse,
  IGetFlatTourBookingScheduleResponse,
  IGetFlatTourBookingScheduleResponseError,
} from './types';

export const defaultConfig: TGetFlatTourBookingScheduleModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'newbuilding-calltracking',
  pathApi: '/v1/get-flat-tour-booking-schedule',
  responseType: 'json',
} as TGetFlatTourBookingScheduleModel;

export function createGetFlatTourBookingScheduleModel(
  parameters: IGetFlatTourBookingScheduleRequest,
): TGetFlatTourBookingScheduleModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetFlatTourBookingScheduleOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetFlatTourBookingScheduleRequest;
}

export async function fetchGetFlatTourBookingSchedule<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFlatTourBookingScheduleOptions<TResponse200, TResponse400>): Promise<
  TGetFlatTourBookingScheduleResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetFlatTourBookingScheduleModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFlatTourBookingScheduleResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetFlatTourBookingScheduleResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetFlatTourBookingScheduleResponse;
}
